import { useTranslation } from 'react-i18next'
import { XendrelMark } from '@/components/brand/XendrelMark'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { BrandHomeLink } from './BrandHomeLink'

/**
 * The shell's corner cell: the Xendrel mark at the head of the rail, the way
 * home in every mode. It takes the shell's header height, as the top bar does,
 * so their bottom borders meet in one line, and it stays put above the scrolling
 * rail.
 */
export function RailBrand() {
  const { t } = useTranslation()
  return (
    <div className="flex h-shell-header w-full shrink-0 items-center justify-center border-b border-border">
      <Tooltip>
        <TooltipTrigger asChild>
          <BrandHomeLink className="group/brand flex size-10 items-center justify-center rounded-xl text-foreground outline-none transition-colors hover:bg-accent hover:text-primary focus-visible:ring-2 focus-visible:ring-ring">
            <XendrelMark className="size-7 transition-transform duration-300 group-hover/brand:scale-110 motion-reduce:transition-none" />
          </BrandHomeLink>
        </TooltipTrigger>
        <TooltipContent side="right">{t('nav.cases.home')}</TooltipContent>
      </Tooltip>
    </div>
  )
}
